import { lazy } from 'react';

export const MainPageAsync = lazy(async () => import('./MainPage'));
